import { __ } from '@wordpress/i18n';



export const layoutOpt = [
	{ label: __('Swipe', 'product-swiper'), value: 'swipe' },
	{ label: __('Grid', 'product-swiper'), value: 'grid' },
]

export const orderByOpt = [
	{ label: __('Default', 'product-swiper'), value: 'menu_order' },
	{ label: __('ID', 'product-swiper'), value: 'ID' },
	{ label: __('Title', 'product-swiper'), value: 'title' },
	{ label: __('Date', 'product-swiper'), value: 'date' }
]

export const orderOpt = [
	{ label: __('DESC', 'product-swiper'), value: 'desc' },
	{ label: __('ASC', 'product-swiper'), value: 'ASC' },
]


export const aligns = [
	{ label: __('Left', 'swipe-n-buy'), value: 'left', icon: 'editor-alignleft' },
	{ label: __('Center', 'swipe-n-buy'), value: 'center', icon: 'editor-aligncenter' },
	{ label: __('Right', 'swipe-n-buy'), value: 'right', icon: 'editor-alignright' }
];


export const generalStyleTabs = [
	{ name: 'general', title: __('General', 'product swiper') },
	{ name: 'style', title: __('Style', 'product swiper') }
];
